import moment from 'moment';

export const getFormatedDuration = (minutes: number) => {
  const momentDuration = moment.duration(minutes, 'minutes');

  const days = momentDuration.days();
  const hours = momentDuration.hours();
  const min = momentDuration.minutes();

  return `${days ? `${days}j ` : ''}${hours ? `${hours}h ` : ''}${min || (!hours && !days) ? `${min}min` : ''}`;
};
